package nl.staartvin.solarpower.data.model

import kotlinx.datetime.Instant

/** A single UV-index sample at a point in time. */
data class UvPoint(
    val time: Instant,
    val uvi: Double,
) {
    /**
     * ISO-8601 representation of [time], e.g. "2026-06-20T13:00:00Z".
     *
     * Exists so Swift can use `ISO8601DateFormatter` without depending on the
     * mangled `Kotlinx_datetimeInstant` Swift symbol. Kotlin code can keep using [time].
     */
    val timeIso: String get() = time.toString()
}

/**
 * Today's UV picture for one location.
 *
 * - [forecast] is always populated (both data sources provide this).
 * - [measured] is only populated when the source supports it (RIVM in NL). May be empty.
 * - [now] is the source's "current" reading. Convenience field; equals the
 *   latest measured point when available, else interpolated from the forecast.
 */
data class UvDay(
    val location: Location,
    val now: UvPoint,
    val forecast: List<UvPoint>,
    val measured: List<UvPoint>,
    val source: UvSource,
)

enum class UvSource(val displayName: String) {
    RIVM("RIVM (Dutch Health Institute)"),
    CURRENT_UV_INDEX("currentuvindex.com"),
}
